import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';
import { PodsListTableSkeletonComponent } from '../pods-list-table-skeleton/pods-list-table-skeleton.component';

@Component({
  selector: 'app-pods-list-skeleton',
  templateUrl: './pods-list-skeleton.component.html',
  styleUrls: ['./pods-list-skeleton.component.scss'],
  imports: [SkeletonComponent, PodsListTableSkeletonComponent],
})
export class PodsListSkeletonComponent {}